export default {
  title: {
    id: 'gift_cards_title',
    defaultMessage: 'Customize your digital gift card',
  },
  subtitle: {
    id: 'gift_cards_subtitle',
    defaultMessage: 'Stress-free gifting that’s better for the planet.',
  },
}
